import Vue from "vue";
import VueRouter from "vue-router";
import ProductList from "@/views/ProductList";
import NProgress from "nprogress";
import NetworkIssue from "@/views/NetworkIssue.vue";
import NotFound from "@/views/NotFound";
import Checkout from "@/views/Checkout";
import Finish from "@/views/Finish";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "products-list",
    component: ProductList,
    meta: {
      title: "Location de skis à Villard Reculas Au PtitPingouin | Réserver"
    }
  },
  {
    path: "/checkout",
    name: "checkout",
    component: Checkout,
    meta: {
      title: "Location de skis à Villard Reculas Au PtitPingouin | Validation"
    }
  },
  {
    path: "/finish",
    name: "finish",
    component: Finish,
    meta: {
      title: "Location de skis à Villard Reculas Au PtitPingouin | Confirmation"
    }
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    props: true
  },
  {
    path: "/network-issue",
    name: "network-issue",
    component: NetworkIssue
  },
  {
    path: "*",
    redirect: {
      name: "404",
      params: {
        resource: "page"
      }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((routeTo, routeFrom, next) => {
  document.title = routeTo.meta.title || 'Location de skis à Villard Reculas Au PtitPingouin';
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
